import React, { useEffect, useRef } from "react";
import { useState } from "react";
import Shedule from "./Shedule";
import PaymentSuccessful from "./PaymentSuccessful";
import { useDispatch, useSelector } from "react-redux";
import { CommonApiFun } from "../../Redux/Action/index";
import { toast } from "react-toastify";
import ToastMgs from "../Other/ToastMgs";
import { useNavigate } from "react-router-dom";
import { routes } from "../../MainPage";
import moment from "moment";
// import svg from '../img/symbol.svg'

function OldPatient(props) {
  let navigate = useNavigate();
  //const PatientFileInfo = useSelector((state) => state.PatientFileInfo)
  const dispatch = useDispatch();
  const Branch = useSelector((state) => state.clinicInfo);
  const myRef = useRef(null);
  const [state, setState] = useState({
    day: "",
    time: "",
    activeTab: 1,
    isLoading: false,
    res: "",
    Endtime: "",
    razorpay_payment_id: "",
    userImage: "",
    ImageFile: "",
    paymentRes: "",
    appointmnetType: "new",
    fileId: "",
    Age: "",
    fileLoader: false,
    mainTab: 1,
    PatientFileInfo: {},
    branchOption: { show: false, value: Branch[0] },
  });

  const handleChange = (e, Name) => {
    setState((prev) => ({ ...prev, [Name]: e.target.value, error: false }));
  };

  const handleFileChcek = (e) => {
    e.preventDefault();
    //  alert(state.fileId)
    var data = { file_number: state.fileId.trim() };

    if (state.fileId != "") {
      setState((prev) => ({ ...prev, fileLoader: true }));
      //toast(<ToastMgs status={res.status} message={'Patient data added successfully.'} />)
      dispatch(CommonApiFun("api/patient_history/post", JSON.stringify(data)))
        .then(async (res) => {
          setState((prev) => ({ ...prev, fileLoader: false }));

          if (res.status == "success") {
            var { appointment, patient, appointment_data, dieses } = res.data;

            await dispatch({
              type: "PATIENT_FILE_INFO",
              payload: {
                appointment,
                patient,
                fileId: state.fileId.trim(),
                appointment_data,
                dieses,
              },
            });
            setState((prev) => ({
              ...prev,
              res: {
                data: res.data.appointment_data,
                patient: res.data.patient,
                fileId: state.fileId.trim(),
                appointment,
              },
            }));

            //  navigate(routes.AppointmentHistory + "/" + (state.fileId).trim(), { state: res, fileId: (state.fileId).trim() });
          } else {
            //toast.error(res.message)
            toast(<ToastMgs status={res.status} message={res.message} />);
          }
        })
        .catch((e) => {
          setState((prev) => ({ ...prev, fileLoader: false }));
          toast.error("Oops! ,something went wrong try again later...");
        });
    } else {
      toast(<ToastMgs status={"fail"} message={"Please enter your File Id"} />);
    }
  };

  return (
    <div
      id="tab-2"
      className={`appint-tab-content ${
        props.mainTab == 2 ? "appint-tab-current" : ""
      }`}
    >
      <div className="card">
        <div className="form">
          <div className="left-side">
            <div className="steps-content">
              <h3 style={{ display: "none" }}>
                Step <span className="step-number">1</span>
              </h3>
              <div className="step-number-content active">
                <h3>Check File id</h3>
                <p>Enter your file id get history.</p>
              </div>
              <div className="step-number-content d-none">
                <h3>Scheduled & Payment</h3>
                <p>
                  Everything is going according to schedule.Help companies get
                  to know you better by telling then about your past
                  experiences.
                </p>
              </div>
            </div>
            <ul className="progress-bar">
              <li className={`${state.activeTab >= 1 ? "active" : ""}`}>
                <span className="progress-flex">
                  <h4>Check File id</h4>
                  <span className="progress-icons">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216h40C512,443.62,485.371,379.333,437.02,330.98zM256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40c59.551,0,108,48.448,108,108S315.551,256,256,256z" />
                    </svg>
                  </span>
                </span>
              </li>
              <li className={state.activeTab != 1 ? `active` : ""}>
                <span className="progress-flex">
                  <h4>Scheduled & Payment</h4>
                  <span className="progress-icons">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 359.286 359.286"
                    >
                      <path d="m179.643 359.286c99.043 0 179.643-80.6 179.643-179.643s-80.599-179.643-179.643-179.643-179.643 80.6-179.643 179.643 80.6 179.643 179.643 179.643zm0-335.334c85.869 0 155.691 69.821 155.691 155.691s-69.821 155.691-155.691 155.691-155.691-69.821-155.691-155.691 69.822-155.691 155.691-155.691z" />
                      <path d="m232.039 236.89c2.216 1.796 4.85 2.635 7.485 2.635 3.533 0 7.006-1.557 9.341-4.491 4.132-5.15 3.293-12.695-1.856-16.827l-55.39-44.312v-90.061c0-6.587-5.389-11.976-11.976-11.976s-11.976 5.389-11.976 11.976v95.81c0 3.653 1.677 7.066 4.491 9.341z" />
                    </svg>
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <div className="right-side">
            <div className={`main  ${state.activeTab == 1 ? "active" : ""}`}>
              <div className="text">
                <h3>Check File id</h3>
                <p>Enter your file id get history.</p>
              </div>
              <div className="main-content apoint-hist-width">
                <div className="input-text">
                  <div className="input-div">
                    {/* <input type="text" id="user_name" placeholder="Appointment Id" /> */}
                    <input
                      type="text"
                      id="user_name"
                      placeholder="File Id"
                      onChange={(e) => handleChange(e, "fileId")}
                      value={state.fileId}
                    />
                    <span class="not_placeholder">
                      File Id <b>*</b>
                    </span>
                  </div>

                  <button
                    className={`btn next_button btn-relative ${
                      state.fileLoader ? "btn--loading" : ""
                    }`}
                    onClick={(e) => {
                      handleFileChcek(e);
                    }}
                  >
                    <span className="btn-text">Check</span>
                    <span className="btn__loader">
                      <div
                        role="progressbar"
                        aria-valuemin={0}
                        aria-valuemax={100}
                        className="progress-circular progress-circular--visible progress-circular--indet"
                        style={{ height: 23, width: 23 }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="21.904761904761905 21.904761904761905 43.80952380952381 43.80952380952381"
                          style={{ transform: "rotate(0deg)" }}
                        >
                          <circle
                            fill="transparent"
                            cx="43.80952380952381"
                            cy="43.80952380952381"
                            r={20}
                            strokeWidth="3.8095238095238093"
                            strokeDasharray="125.664"
                            strokeDashoffset="125.66370614359172px"
                            className="progress-circular__overlay"
                          />
                        </svg>
                      </div>
                    </span>
                  </button>
                </div>
                {state.res != "" && (
                  <div className="assin_doctorsbox">
                    <div className="assin_doctorsbox-header">
                      <h4 className="assin_doctorsbox-title">
                        Appointment History
                      </h4>
                      <a
                        href="javascript:void(0)"
                        class="book_trigger"
                        onClick={() =>
                          setState((prev) => ({ ...prev, activeTab: 2 }))
                        }
                      >
                        Book a New Appointment
                      </a>
                    </div>
                    <div className="assin_doctorsbox-body">
                      <div className="assin_doctorsbox-body">
                        {state.res.appointment.map(
                          ({
                            appointment_date,
                            appointment_end_time,
                            appointment_start_time,
                            created_date,
                            appointment_by,
                          }) => {
                            var DayDiff = moment(
                              moment().format("YYYY-MM-DD")
                            ).diff(moment(appointment_date), "days");

                            return (
                              <div className="assin_doctorsbox-item">
                                <h4>{appointment_date}</h4>
                                <p>
                                  {moment(
                                    appointment_start_time,
                                    "hh:mm"
                                  ).format("LT")}
                                </p>
                                <span>
                                  {DayDiff >= 1
                                    ? "Past"
                                    : DayDiff == 0
                                    ? "Today"
                                    : "Upcoming"}
                                </span>
                                <span>
                                  {appointment_by == 0
                                    ? "By Online"
                                    : DayDiff == 1
                                    ? "By Call"
                                    : "By Clinic"}
                                </span>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <Shedule
              handleState={(name, value) => {
                setState((prev) => ({ ...prev, [name]: value }));
              }}
              isoldPatient={true}
              data={state}
              handlePrev={() => {
                setState((prev) => ({ ...prev, activeTab: 1 }));
              }}
              handleNext={() => {
                setState((prev) => ({ ...prev, activeTab: 4 }));
              }}
            ></Shedule>

            <PaymentSuccessful
              activeTab={4}
              data={state}
              isoldPatient={true}
              handleBack={() => {
                setState({
                  day: "",
                  time: "",
                  activeTab: 1,
                  isLoading: false,
                  res: "",
                  Endtime: "",
                  razorpay_payment_id: "",
                  userImage: "",
                  ImageFile: "",
                  paymentRes: "",
                  appointmnetType: "new",
                  fileId: "",
                  Age: "",
                  fileLoader: false,
                  PatientFileInfo: {},
                  branchOption: { show: false, value: Branch[0] },
                });
              }}
            ></PaymentSuccessful>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OldPatient;
